import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Typography, Tooltip } from "antd";
import { fetchAppPages } from "../../Services/privacy_policy";
import CustomTable from "../../Component/Table";

const { Text } = Typography;

const AppPageList = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["app_pages"],
    queryFn: fetchAppPages,
    refetchOnWindowFocus: false,
    retry: false,
  });
  const deepLinkBaseUrl = data?.deep_link_base_url || "";
  

  const columns = [
    {
      title: "Page Name",
      dataIndex: "page_name",
      key: "page_name",
    },
    {
      title: "Page Path",
      dataIndex: "page_path",
      key: "page_path",
      render: (value) => {
        if (!value) return "-";
        value = deepLinkBaseUrl + value
        const shortPath = value.length > 50 ? `${value.slice(0, 50)}...` : value;

        return (
            <Tooltip title={`${value}`}>
                <Text copyable={{ text: `${value}` }}>
                {`${shortPath}`}
                </Text>
            </Tooltip>
        );

      },
    },
  ];

  return (
    <div>
      <h3>App Page List</h3>

      <CustomTable
        columns={columns}
        data={data?.data || []}
        loading={isLoading}
        rowKey="id"
        pagination={false}
      />
    </div>
  );
};

export default AppPageList;
